/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap-sass');
    require('../../../node_modules/slick-carousel/slick/slick.min.js');
    require('../../../node_modules/jquery-validation/dist/jquery.validate.min.js');
    require('../../../node_modules/jquery-ui/ui/widgets/slider');
} catch (e) {}



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js